<template>
  <div class="LKRoadmapsFeedIndex">
    <transition name="fade-slow" mode="out-in">
      <keep-alive>
        <router-view
          @open-dialog="onOpenDialog"
          @add-direction="onAddDirection"
          @add-files="onLoadFiles"
          @remove-file="onRemoveFile"
          @remove-direction="onRemoveDirection"
          @open-history="onOpenHistory"
        />
      </keep-alive>
    </transition>

    <portal to="app-outlet">
      <LKRoadmapsFeedDialog
        v-if="options.dialog"
        :options="options.dialog"
        :profile="profile"
        @close="options.dialog = null"
      />

      <LKRoadmapsFeedModalNames
        v-if="options.roadmap"
        :options="options.roadmap"
        @close="onFeedModalNamesClosed"
      />

      <LKRoadmapsFeedModalConfirm
        v-if="options.confirm"
        :options="options.confirm"
        @close="options.confirm = null"
      />

      <LKRoadmapsFeedModalLoadFiles
        v-if="options.loadFiles"
        :options="options.loadFiles"
        @close="options.loadFiles = null"
      />

      <LKRoadmapsFeedModalHistoryTable
        v-if="options.history"
        :options="options.history"
        @close="options.history = null"
      />
    </portal>
  </div>
</template>

<script>
/** @typedef {import('@/components/forms/BAteTree/utils').TreeNode} TreeNode */

import { rootMapper } from '@/store/modules/root'
import { lkMapper } from '@/store/modules/lk'
import { RoadmapDirectionsFeedApi, RoadmapEventsApi } from '@/api/resources'

import LKRoadmapsFeedDialog from './components/Modals/LKRoadmapsFeedDialog.vue'
import LKRoadmapsFeedModalNames from './components/Modals/LKRoadmapsFeedModalNames.vue'
import LKRoadmapsFeedModalConfirm from './components/Modals/LKRoadmapsFeedModalConfirm.vue'
import LKRoadmapsFeedModalLoadFiles from './components/Modals/LKRoadmapsFeedModalLoadFiles.vue'
import LKRoadmapsFeedModalHistoryTable from './components/Modals/LKRoadmapsFeedModalHistoryTable.vue'

export default {
  name: 'LKRoadmapsFeedLayout',
  provide() {
    return {
      $eventId: () => this.eventId,
      isAdresat: this.isAdresat,
      isCurator: this.isCurator,
      isExpert: this.isExpert,
      isCoordinator: this.isCoordinator,
    }
  },
  components: {
    LKRoadmapsFeedDialog,
    LKRoadmapsFeedModalNames,
    LKRoadmapsFeedModalConfirm,
    LKRoadmapsFeedModalLoadFiles,
    LKRoadmapsFeedModalHistoryTable,
  },
  data() {
    return {
      options: {
        dialog: null,
        roadmap: null,
        confirm: null,
        loadFiles: null,
        history: null,
      },
      eventId: null,
    }
  },
  computed: {
    ...rootMapper.mapGetters(['profile']),
    ...lkMapper.mapGetters(['isAdresat', 'isCurator', 'isCoordinator', 'isExpert']),
  },
  mounted() {
    const { eventId } = this.$route.params
    this.eventId = eventId
  },
  methods: {
    /** @param {TreeNode} node */
    onOpenDialog(node) {
      this.options.dialog = {
        node,
        event_id: node.data.id,
        event_name: node.data.name,
        event_status: node.data.status,
      }
    },
    /** @param {TreeNode} node */
    onAddDirection(node) {
      this.options.roadmap = {
        node,
        roadmap_id: node.data.id,
        school_id: node.parent.data.id,
      }
    },
    onFeedModalNamesClosed(flag) {
      if (!flag) {
        this.options.roadmap = null
        return
      }

      const { node } = this.options.roadmap
      node.update()
      this.options.roadmap = null
    },
    /** @param {TreeNode} node */
    onRemoveDirection(node) {
      const api = new RoadmapDirectionsFeedApi()
      const directionId = node.data.id

      this.options.confirm = {
        node,
        title: 'Вы уверены, что хотите удалить направление?',
        action: async () => {
          await api.delete(directionId)
          const { parent } = node

          if (parent && Array.isArray(parent.children)) {
            const children = parent.children
              .filter((child) => child.data.id !== node.data.id)
              .map((child) => child.data)
            parent.setChildren(children, parent.isLast, parent.isActive)
          }
        },
      }
    },
    /** @param {TreeNode} eventNode; @param {TreeNode} fileNode  */
    onRemoveFile(eventNode, fileNode) {
      const api = new RoadmapEventsApi()
      const eventId = eventNode.data.id
      const fileId = fileNode.data.id

      this.options.confirm = {
        node: eventNode,
        eventNode,
        fileNode,
        title: 'Вы уверены, что хотите удалить файл?',
        action: async () => {
          await api.deleteFile(eventId, fileId)
          const data = eventNode.children
            .filter((child) => child.data.id !== fileId)
            .map((child) => child.data)
          // eslint-disable-next-line no-param-reassign
          eventNode.data.files = data
          eventNode.setChildren(data, eventNode.isLast, eventNode.isActive)
          eventNode.update()
        },
      }
    },
    /** @param {TreeNode} node */
    onLoadFiles(node, files) {
      this.options.loadFiles = {
        node,
        files,
        event_id: node.data.id,
      }
    },
    /** @param {TreeNode} node */
    onOpenHistory(node) {
      this.options.history = {
        node,
        event_id: node.data.id,
      }
    },
  },
}
</script>

<style lang="scss" src="@/assets/scss/transitions/transition-fade.scss"></style>
